import { useRef } from 'react';

import { overlay } from './HiveOverlay.sty.js';
import { HoneycombToolbar } from './toolbar/HoneycombToolbar.js';
import { HiveTooltip } from './tooltip/HiveTooltip.js';
import { useGraphSize } from '../../core/components/chart-layout/hooks/useGraphSize.js';
import { useOverlayEvents } from '../hooks/use-overlay-events.js';
import { useTooltipEventListeners } from '../hooks/use-tooltip-event-listeners.js';

export const HiveOverlay = () => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  const {
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleMouseClick,
  } = useOverlayEvents();

  const { height, width } = useGraphSize();

  useTooltipEventListeners(tooltipRef.current);

  return (
    <div
      className={overlay}
      style={{
        height,
        width,
      }}
      data-testid="honeycomb-overlay"
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={handleMouseClick}
    >
      <HiveTooltip ref={tooltipRef} />
      <HoneycombToolbar />
    </div>
  );
};

HiveOverlay['displayName'] = 'HiveOverlay';
